var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-list-group",
    [
      _c("mds-list-group-item", {
        staticClass: "general-tab__title",
        attrs: { text: "Name", microcopy: _vm.name },
      }),
      _vm._v(" "),
      _vm._l(_vm.arrayItems, function (item, key) {
        return _c("mds-list-group-item", {
          key: key,
          staticClass: "general-tab__title",
          attrs: {
            text: _vm.getCapTitle(item[0]),
            microcopy: _vm.getPropValue(item[0], item[1]),
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }